import { createSlice } from "@reduxjs/toolkit";
const identification = createSlice({
  name: "identification",
  initialState: {
    login: false,
  },
  reducers: {
    setAuth(state, { payload }) {
      state.login = payload;
    },
  },
});
export const { setAuth } = identification.actions;
export default identification.reducer;
